import {Injectable} from "@angular/core";
import {CustomerPortalStatusData} from "./customer-portal-status.data";
import {CustomerPortalService} from "./customer-portal.service";

export enum CustomerPortalPages {
    BILLING,
    COMPLETE,
    FAILED,
    EXPIRED
}

@Injectable()
export class CustomerPortalModel {

    customerPortalStatus: CustomerPortalStatusData;

    activePage: CustomerPortalPages = CustomerPortalPages.BILLING;

    constructor(private customerPortalService: CustomerPortalService) {
    }

    get venueId(): string {
        return this.customerPortalStatus.venueId;
    }

    async load(): Promise<void> {
        try {
            this.customerPortalStatus = await this.customerPortalService.getCustomerPortalStatus();
        } catch (e) {
            if (e.status === 401) {
                this.activePage = CustomerPortalPages.EXPIRED;
            } else {
                this.activePage = CustomerPortalPages.FAILED;
            }
        }
    }

    async confirmBilling(paymentMethodId: string): Promise<void> {
        await this.customerPortalService.confirmPaymentMethod(this.venueId, paymentMethodId);
        this.activePage = CustomerPortalPages.COMPLETE;
    }

    async refresh(): Promise<void> {
        await this.load();
    }
}
